import { render } from "./ConfirmDialog.vue?vue&type=template&id=98e651e4&scoped=true"
import script from "./ConfirmDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmDialog.vue?vue&type=script&lang=js"

import "./ConfirmDialog.vue?vue&type=style&index=0&id=98e651e4&lang=scss&scoped=true"

import exportComponent from "/Users/emiliedannenberg/Documents/GitHub/nola-paddle-routes/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98e651e4"]])

export default __exports__